/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/allas/components/standalone/RadioButton/theme';

export const RadioButtonTheme = theme;
